import React from 'react';
import { useTranslation } from 'next-i18next';
import { create, InstanceProps } from 'react-modal-promise';
import { useRouter } from 'next/router';

import { IconButton } from 'components';
import { ButtonV3 } from 'components/ComponentV2';
import Modal from 'components/Modal';
import { PAGE_ROUTES } from 'lib/page-routes';

import styles from './NoSavedOpportunitiesModal.module.scss';

type ModalInstanceProps = InstanceProps<void>;

const ModalInstance: React.FC<ModalInstanceProps> = ({ isOpen, onResolve, onReject }) => {
  const [t] = useTranslation('opportunity');
  const router = useRouter();

  return (
    <Modal isOpen={isOpen} onRequestClose={onReject} contentClassName={styles.container}>
      <IconButton size="xsmall" iconName="close" className={styles['cancel-icon']} onClick={() => onReject()} />
      <p className={styles.emoji}>😵‍💫</p>
      <p className={styles.title}>{t('no-saved-jobs-modal.title')}</p>
      <p className={styles.detail}>{t('no-saved-jobs-modal.desc')}</p>
      <ButtonV3
        size="large"
        isFullWidth
        onClick={() => {
          router.push(PAGE_ROUTES.SEARCH_RESULTS);
          onResolve();
        }}
      >
        {t('no-saved-jobs-modal.primary-cta')}
      </ButtonV3>
      <ButtonV3 size="large" variant="text" onClick={() => onReject()} className={styles['text-button']} color="secondary" isFullWidth>
        {t('no-saved-jobs-modal.secondary-cta')}
      </ButtonV3>
    </Modal>
  );
};

export const noSavedOpportunitiesModalInstance = create(ModalInstance);
